export default __webpack_public_path__ + "static/media/org_level.6dc3135c.svg";